import darken from 'polished/lib/color/darken';
import styled from 'styled-components';
import { Type, Variant } from './toast';

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */

export const ToastWrapper = styled.div<{
  type?: Type;
  fullWidth?: boolean;
  removeSpacing?: boolean;
}>`
  display: flex;
  border-radius: ${({ theme }): string => theme.border_radius_x2};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  min-width: 120px;
  width: ${({ fullWidth }): string => (fullWidth ? 'auto' : '25vw')};
  margin: ${({ removeSpacing, theme }): string =>
    removeSpacing ? '0' : theme.spacing_unit_x2};
  padding: ${({ theme }): string => theme.spacing_unit_x2};

  ${({ theme, type }): { [key: string]: string } => {
    if (type === 'warning') {
      return {
        backgroundColor: theme.palette_warning_5,
        border: `1px solid ${theme.palette_warning_50}`
      };
    }

    return {
      backgroundColor: theme.palette_white
    };
  }};
`;

export const ToastText = styled.span``;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */

export const HorizontalToastWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
  width: 100%;
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const VerticalToastWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 50px;
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const CloseIconWrapper = styled.button`
  background-color: transparent;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  cursor: pointer;

  &:hover {
    svg {
      stroke: #000000;
    }
  }
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const TextIconWrapper = styled.div<{ variant?: Variant }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${({ variant }): { [key: string]: string } => {
    if (variant === 'horizontal') {
      return {
        fontWeight: '400'
      };
    } else {
      return {};
    }
  }};

  svg {
    fill: ${({ theme }): string => theme.palette_alert_50};
    height: 16px;
    margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  }
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const ActionButton = styled.button<{ topMargin?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }): string => theme.palette_blue_100};
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  margin-top: ${({ theme, topMargin }): string =>
    topMargin ? theme.border_radius_x1 : '0'};
  background-color: transparent;
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  border: none;
  font-weight: 600;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${({ theme }): string => `${darken(0.1, theme.palette_blue_100)}`};
  }
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const VerticalToastHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

/**
 * @deprecated This component is deprecated. Please use the new Toast component from @payflip/ui/v2 instead.
 */
export const SpacingWrapper = styled.div`
  margin-top: ${({ theme }): string => theme.spacing_unit_x1};
`;
